export default __webpack_public_path__ + "static/lsa-website-3-c27a70383a3468b17e2c47eb74044378.jpg";